import { GetStaticProps } from 'next';
import { CorporateContactJsonLd, NextSeo, SocialProfileJsonLd } from 'next-seo';
import React from 'react';

import StyledComponent from '@/components/StyledComponent';
import ECommerceContainer from '@/containers/ECommerce';
import Layout from '@/providers/Layout';
import { stoneCMSGetBy } from '@/services/stoneCMSApi';
import {
  BannerCardProps,
  BannerProps,
  ImageCMSProps,
  ImageResponsiveCMSProps,
} from '@/types/cms';

export interface ShopProps {
  banner: BannerProps;
  enterprisesCard: {
    id: string;
    referId: string;
    title: string;
    images: ImageCMSProps[];
  };
  bannerCards: {
    id: string;
    referId: string;
    title: string;
    subTitle: string;
    pagarmeImages: ImageCMSProps;
    bannerCards: BannerCardProps[];
  };
  featureCards: {
    id: string;
    referId: string;
    title: string;
    description: string;
    ImageResponsive: ImageResponsiveCMSProps;
  }[];
}

export const getStaticProps: GetStaticProps<ShopProps> = async () => {
  const props = await stoneCMSGetBy('solucao-de-pagamento-digital');

  return {
    props,
  };
};

const Lojinha: React.FC<ShopProps> = props => (
  <>
    <NextSeo
      title="Soluções de Pagamentos Digitais - Stone"
      description="A Stone também atende seu negócio digital. A Pagar.me é a nossa tecnologia de pagamento para pequenos e grandes negócios do mundo online"
      canonical="https://www.stone.com.br/solucoes-de-pagamentos-digitais/"
      openGraph={{
        type: 'website',
        url: 'https://www.stone.com.br/solucoes-de-pagamentos-digitais/',
        title: 'Soluções de Pagamentos Digitais - Stone',
        description:
          'A Stone também atende seu negócio digital. A Pagar.me é a nossa tecnologia de pagamento para pequenos e grandes negócios do mundo online',
        images: [
          {
            url: 'https://res.cloudinary.com/dunz5zfpt/image/upload/v1666733343/site-stone/structured-data/e-commerce/e-commerce-img-400x400.png',
            width: 400,
            height: 400,
            alt: 'Soluções de Pagamentos Digitais - Stone',
            type: 'image/png',
          },
          {
            url: 'https://res.cloudinary.com/dunz5zfpt/image/upload/v1666733343/site-stone/structured-data/e-commerce/e-commerce-img-400x246.png',
            width: 400,
            height: 246,
            alt: 'Soluções de Pagamentos Digitais - Stone',
            type: 'image/png',
          },
          {
            url: 'https://res.cloudinary.com/dunz5zfpt/image/upload/v1666733344/site-stone/structured-data/e-commerce/e-commerce-img-400x300.png',
            width: 400,
            height: 300,
            alt: 'Soluções de Pagamentos Digitais - Stone',
            type: 'image/png',
          },
        ],
        site_name: 'Stone',
        locale: 'pt_BR',
      }}
    />
    <CorporateContactJsonLd
      url="http://www.stone.com.br/"
      logo="https://www.stone.com.br/public/images/favicon.ico"
      contactPoint={[
        {
          telephone: '3004-9680',
          contactType: 'customer service',
          areaServed: 'BR',
          availableLanguage: ['Brazilian Portuguese'],
        },
        {
          telephone: '3004-9681',
          contactType: 'sales',
          areaServed: 'BR',
          availableLanguage: ['Brazilian Portuguese'],
        },
        {
          telephone: '0800 326-0506',
          contactType: 'customer service',
          areaServed: 'BR',
          contactOption: 'TollFree',
          availableLanguage: ['Brazilian Portuguese'],
        },
      ]}
    />
    <SocialProfileJsonLd
      type="Organization"
      name="Stone Pagamentos"
      url="http://www.stone.com.br/"
      sameAs={[
        'https://www.facebook.com/stonepagamentos/',
        'https://twitter.com/sejastone',
        'https://www.instagram.com/stone/',
        'https://www.youtube.com/channel/UCk4L4JykgoDkN8YeuxkNqIQ',
        'https://www.linkedin.com/company/stone-pagamentos',
        'https://pt.wikipedia.org/wiki/Stone_Pagamentos',
      ]}
    />
    <Layout layoutName="default">
      <StyledComponent>
        <ECommerceContainer {...props} />
      </StyledComponent>
    </Layout>
  </>
);

export default Lojinha;
